module.exports = __webpack_public_path__ + "img/custom-meeting-clock.b7e274d8.svg";